import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  // List Scripts
  scriptsListRequest: ['params', 'callback'],
  scriptsListSuccess: ['list'],
  scriptsListFailure: ['error'],

  // Get Script Detail
  scriptDetailRequest: ['id', 'callback'],
  scriptDetailSuccess: ['detailData'],
  scriptDetailFailure: ['error'],

  // Create Script
  scriptCreateRequest: ['topic', 'settings', 'callback'],
  scriptCreateSuccess: ['data'],
  scriptCreateFailure: ['error'],

  // Update Script
  scriptUpdateRequest: ['id', 'params', 'callback'],
  scriptUpdateSuccess: ['data'],
  scriptUpdateFailure: ['error'],

  // Update Script Content
  scriptUpdateContentRequest: ['id', 'content', 'callback'],
  scriptUpdateContentSuccess: [],
  scriptUpdateContentFailure: ['error'],

  // Update Script Step
  scriptUpdateStepRequest: ['id', 'step', 'callback'],
  scriptUpdateStepSuccess: [],
  scriptUpdateStepFailure: ['error'],

  // Poll Script Status
  scriptPollRequest: ['id', 'callback'],
  scriptPollSuccess: ['status'],
  scriptPollFailure: ['error'],

  // Surprise Script
  scriptSurpriseRequest: ['callback'],
  scriptSurpriseSuccess: ['data'],
  scriptSurpriseFailure: ['error'],

  // Regenerate Script
  scriptRegenerateRequest: ['id', 'callback'],
  scriptRegenerateSuccess: ['data'],
  scriptRegenerateFailure: ['error'],

  // Prompt Ideas
  scriptPromptIdeasRequest: ['params', 'callback'],
  scriptPromptIdeasSuccess: ['ideas'],
  scriptPromptIdeasFailure: ['error'],

  // Generate Hooks
  scriptGenerateHooksRequest: ['params', 'callback'],
  scriptGenerateHooksSuccess: ['hooks'],
  scriptGenerateHooksFailure: ['error'],

  // Set current script
  setCurrentScript: ['script'],
  clearCurrentScript: [],

  // Reset
  scriptsReset: [],
})

export const ScriptTypes = Types
export default Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  // List
  list: [],
  listFetching: false,
  listError: null,

  // Detail
  detailData: null,
  detailFetching: false,
  detailError: null,

  // Create
  createFetching: false,
  createError: null,
  createdData: null,

  // Update
  updateFetching: false,
  updateError: null,

  // Poll
  polling: false,
  pollStatus: null,
  pollError: null,

  // Current script being worked on
  currentScript: null,
}

/* ------------- Reducer ------------- */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // List
    case Types.SCRIPTS_LIST_REQUEST:
      return { ...state, listFetching: true, listError: null }
    case Types.SCRIPTS_LIST_SUCCESS:
      return { ...state, list: action.list, listFetching: false, listError: null }
    case Types.SCRIPTS_LIST_FAILURE:
      return { ...state, listFetching: false, listError: action.error }

    // Detail
    case Types.SCRIPT_DETAIL_REQUEST:
      return { ...state, detailFetching: true, detailError: null }
    case Types.SCRIPT_DETAIL_SUCCESS:
      return { ...state, detailData: action.detailData, detailFetching: false, detailError: null }
    case Types.SCRIPT_DETAIL_FAILURE:
      return { ...state, detailFetching: false, detailError: action.error }

    // Create
    case Types.SCRIPT_CREATE_REQUEST:
      return { ...state, createFetching: true, createError: null }
    case Types.SCRIPT_CREATE_SUCCESS:
      return { ...state, createFetching: false, createError: null, createdData: action.data }
    case Types.SCRIPT_CREATE_FAILURE:
      return { ...state, createFetching: false, createError: action.error }

    // Update (shared by update, updateContent, updateStep)
    case Types.SCRIPT_UPDATE_REQUEST:
    case Types.SCRIPT_UPDATE_CONTENT_REQUEST:
    case Types.SCRIPT_UPDATE_STEP_REQUEST:
      return { ...state, updateFetching: true, updateError: null }
    case Types.SCRIPT_UPDATE_SUCCESS:
    case Types.SCRIPT_UPDATE_CONTENT_SUCCESS:
    case Types.SCRIPT_UPDATE_STEP_SUCCESS:
      return { ...state, updateFetching: false, updateError: null }
    case Types.SCRIPT_UPDATE_FAILURE:
    case Types.SCRIPT_UPDATE_CONTENT_FAILURE:
    case Types.SCRIPT_UPDATE_STEP_FAILURE:
      return { ...state, updateFetching: false, updateError: action.error }

    // Regenerate (reuses create state)
    case Types.SCRIPT_REGENERATE_REQUEST:
      return { ...state, createFetching: true, createError: null }
    case Types.SCRIPT_REGENERATE_SUCCESS:
      return { ...state, createFetching: false, createError: null, createdData: action.data }
    case Types.SCRIPT_REGENERATE_FAILURE:
      return { ...state, createFetching: false, createError: action.error }

    // Poll
    case Types.SCRIPT_POLL_REQUEST:
      return { ...state, polling: true, pollError: null }
    case Types.SCRIPT_POLL_SUCCESS:
      return { ...state, polling: false, pollStatus: action.status, pollError: null }
    case Types.SCRIPT_POLL_FAILURE:
      return { ...state, polling: false, pollError: action.error }

    // Current Script
    case Types.SET_CURRENT_SCRIPT:
      return { ...state, currentScript: action.script }
    case Types.CLEAR_CURRENT_SCRIPT:
      return { ...state, currentScript: null }

    // Reset
    case Types.SCRIPTS_RESET:
      return { ...INITIAL_STATE }

    default:
      return state
  }
}
